import { createSimpleCustomFieldsApi } from '..';
import { ItemType } from '../domain';
export * from './domains';
export * from './dto';
export * from './builder';
export var createCompaniesApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/companies");
    return {
        getAllCompanies: function () { return http.get("".concat(url)); },
        getCompany: function (dto) { return http.get("".concat(url, "/").concat(dto.id)); },
        deleteCompany: function (dto) { return http.delete("".concat(url, "/").concat(dto.id)); },
        addCompany: function (dto) { return http.post("".concat(url), dto); },
        bulkAddCompanies: function (dto) { return http.post("".concat(url, "/bulk"), dto); },
        updateCompany: function (dto) { return http.put("".concat(url, "/").concat(dto.id), dto); },
        search: function (dto) { return http.post("".concat(url, "/search/admin"), dto); },
        customFields: createSimpleCustomFieldsApi("".concat(url), http, ItemType.COMPANY),
        updateCompanyCustomFields: function (dto) {
            return http.put("".concat(url, "/").concat(dto.id, "/fields"), dto);
        },
        companyEmailDomainsCheck: function (dto) {
            return http.post("".concat(url, "/emailDomains/check"), dto);
        },
    };
};
//# sourceMappingURL=index.js.map